import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DepositPromotionMutationKeys } from '../../../keys'
import {
	UpdateDepositPromotionRequest,
	UpdateDepositPromotionResponse,
} from '../../../type'
import { updateDepositPromotion } from '../../services'

interface UpdateDepositPromotionParams {
	id: string
	payload: UpdateDepositPromotionRequest
}

export default function useMutationUpdateDepositPromotion(
	props?: UseBaseMutationOptions<
		UpdateDepositPromotionResponse,
		UpdateDepositPromotionParams
	>,
) {
	return useMutation({
		mutationKey: [DepositPromotionMutationKeys.UpdateDepositPromotion],
		mutationFn: (params) => updateDepositPromotion(params.id, params.payload),
		...props,
	})
}
